module.exports = __webpack_public_path__ + "img/38b)(Mövenpick Hotel Paris) Montage der gesamten Gästezimmer.jpg";